import React, { useMemo } from 'react';

import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import type { OwnerWorkspaceMetrics } from 'config/api/assetRopa/assetRopaWorkspace.types';
import processing_activities_messages from 'messages/processing_activities_messages';

import useStyles from '../../ProcessingActivitiesAssetReviewsPage/ProcessingActivitiesAssetReviewsPage.styles';

type Props = {
  metrics?: OwnerWorkspaceMetrics;
};

const OwnerWorkspaceMetricsSection: React.FC<Props> = ({ metrics }) => {
  const { t } = useTranslation();
  const styles = useStyles();
  const messages = processing_activities_messages.asset_ropa.owner_workspace.metrics;

  const metricItems = useMemo(
    () => [
      { key: 'gdprRelevantAssetsCount' as const, label: t(messages.gdpr_relevant_assets), note: t(messages.owner_scope_note) },
      { key: 'assetsWithoutProcessingActivitiesCount' as const, label: t(messages.without_processing_activities) },
      { key: 'incompleteProcessingsCount' as const, label: t(messages.incomplete_processings) },
      { key: 'dpiaIndicationsCount' as const, label: t(messages.dpia_indications) },
      { key: 'thirdCountryProcessingCount' as const, label: t(messages.third_country_processing) },
      { key: 'sensitivePersonalDataCount' as const, label: t(messages.sensitive_personal_data) },
    ],
    [messages, t],
  );

  if (!metrics) return null;

  return (
    <section aria-label={t(messages.aria_label)} className={styles.metricsRow}>
      {metricItems.map(item => (
        <div key={item.key} className={styles.metricCard}>
          <div className={styles.metricLabel}>{item.label}</div>
          <div className={styles.metricValueLine}>
            <div className={styles.metricValue}>{metrics[item.key]}</div>
          </div>
          {item.note && <div className={clsx(styles.metricLabel, styles.metricNote)}>{item.note}</div>}
        </div>
      ))}
    </section>
  );
};

export default OwnerWorkspaceMetricsSection;
